module.exports = __webpack_public_path__ + "media/customizations/regencyatoldetowne/back-f67d57b645e933d101f3eae75c773306.jpg";